module.exports = __webpack_public_path__ + "static/media/17a.d6ee9155.jpg";